module.exports = __webpack_public_path__ + "static/img/11.d0a04c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/11.png
// module id = RBiw
// module chunks = 0